
$(document).ready(function(){

$(window).on("load" , function(){
	$("body").removeClass("animated")
})

		$(".block_filter_tab_close").on("click" , function(){
			$(this).parents(".block__colletion_filter").find(".block__colletion_filter_inner").slideToggle();
			$(this).parents(".block__colletion_filter").find(".block_filter_tab_close_svg").toggleClass("active");
			$(this).parents(".block__colletion_filter").find(".block_filter_tab_filter_svg").toggleClass("active");
		 })
		
		$(document).on("change" , ".block_qutity_selectbox" ,function(){
			let qty = $(this).val();
			$(this).parents(".form_quick_add").find(".quantity").attr("value" , qty);
	 })
	//  =====filter-selling-plan-box===========
		$(document).on("change" , ".selling_plan_dropdown" , function(){		
			let selVal = $(this).val();			
			$(this).parents(".grid__item").find(".block_selling_plan_id").val(selVal)
		})

	 $(".block_filter_button").on("click" , function(){	
		$(".mobile-facets__disclosure").trigger("click")
		$(".mobile-facets__disclosure").addClass("menu-opening");
		$(".mobile-facets__disclosure").attr("open" , "open")
		$(".collection_sidebar").toggleClass("active");
		$(".product-grid-container").toggleClass("active");
	 })

$(document).on("click" , ".block_close_icon svg"  ,function(){
	$(".mobile-facets__close.mobile-facets__close--no-js").trigger("click")
})

$(document).on("change" , ".block_select_flovers_select" ,function(){
  let checkVal = $(this).attr("id")
  let idval = $(this).val();
  $(this).parents(".product__info-wrapper").find(`#clr-${checkVal}`).val(idval);
  if(idval != ""){
     $(this).parents(".block_select_flovers_inner").addClass("active")     
  }else{
     $(this).parents(".block_select_flovers_inner").removeClass("active")  
    $(this).parents(".block_select_flovers_inner").find(".block_opions").show();
  }
   $(this).parents(".block_select_flovers_inner.active").find(".block_opions").hide();
  let mainLen =  $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner").length;
  let mainactlen = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner.active").length;
   if(mainactlen >= mainLen){    
      $(this).parents(".product__info-wrapper").find(".block_submit_button").attr("disabled" , false)
   }
})

$(document).on("click" , ".block_submit_button" , function(){
  let mainLen = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner").length;
  let mainactlen = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner.active").length;
  if(mainactlen == mainLen){
     $(this).attr("disabled" , false)   
   }else{
     $(this).attr("disabled" , true) 
   }
  $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner .block_opions").show();
  $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner.active .block_opions").hide();
})

$(document).on("click" ,".mobile-facets__summary" , function(){
  $(this).parents(".mobile-facets__details").find(".mobile-facets__list").slideToggle();
  $(this).parents(".mobile-facets__details").find(".mobile-facets__arrow").toggleClass("active");  
})



$(".block_recover_passward").click(function(e){
	e.preventDefault();
	$(this).attr("disabled" , true)
	var form = $(this).parents("#RecoverPasswordForm");
	$.ajax({
		type: "POST",
		url: '/account/recover',
		dataType: 'HTML',
		data: form.serialize(),
		success: function(response) {
	
			if ($(response).find('.note--success-main').length ) {
				// window.location.href='/';
			  $(".block_recover_passward_done").removeClass("hidden");
			  $(".notes--success").addClass("hidden");
             $("#RecoverEmail").val("");
                $(".form-to-many-attemp").addClass("hidden")
			}else {
			  $(".notes--success").removeClass("hidden");
			  $(".form-to-many-attemp").addClass("hidden")
			  $(".block_recover_passward_done").addClass("hidden");
			}
			$(".block_recover_passward").attr("disabled" , false)
		},
		error: function(error){
		  $(".notes--success").addClass("hidden");
		  $(".form-to-many-attemp").removeClass("hidden").text("Too many attempts: Please try again later.");
		  $(".block_recover_passward_done").addClass("hidden");
		  $(".block_recover_passward").attr("disabled" , false)
		}
	});
	});





$(".button_action button.blue_btn").click(function(e) {
	e.preventDefault();
	$(this).attr("disabled" , true)
	var form = $(this).parents("form");
	$(".block__sites-form-error").addClass("hidden");
	$.ajax({
		type: "POST",
		url: '/account/login',
		dataType: 'HTML',
		data: form.serialize(),
		success: function(response) {
			$(".button_action button.blue_btn").attr("disabled" , false)
			$(this).attr("disabled" , true)
			if ($(response).find('.errors').length == 0) {
				window.location.href='/';
				// $.ajax({
				// 	type: "POST",
				// 	url: '/cart/clear.js',
				// 	dataType: 'json',
				// 	success: function() {
				// 		window.location.href='/';
				// 	}
				// })			
			} else {
				$(".block__sites-form-error").removeClass("hidden");
			}
		}
	});
});


$(document).on("click" , ".block_button_text_wholsale" , function(){
  $('.wholesale_main .btn[type="submit"]').trigger("click");
})

$(document).on("click" , ".order_heading_right" , function(){
  $(this).parents(".block_data_order_inner").find(".block_data_order_bottom").slideToggle();
  $(this).parents(".block_data_order_inner").find(".block_data_order_top").toggleClass("open")
 
})


  $(document).on("change" , ".block_free_product_inner_info_varients" , function(){
    $(this).parents(".block_free_product_inner_data").find(".block_free-gift-add-btn").attr("data-id" , $(this).find(":selected").attr("data-id"))
  })

  $(document).on('click','.block_free-gift-add-btn', function(e){
	$(this).attr("disabled"  , true)
	$(this).addClass("active")
	
    e.preventDefault();

    let VarientId = $(this).attr("data-id");
    let Data = {
      id: VarientId,
      quantity: 1,
      properties: {
        'Free-Gift': 'Free Product'
      }
    }   

     $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: Data,
      success: function (product){  
               mincart();
			       
      },
      error: function(error){ 
        console.log("error");
      }
    });
  });

if($(".block__product-fixed-button").length){
    $(window).on('scroll',function(){
      var topHeight = $('.add_to_btn').offset().top;
      var topHeights = $('.add_to_btn').find(".product-form__submit").html();
      $(".block__product-fixed-button-atc").html(topHeights)
        if ($(this).scrollTop() >= topHeight ){
          $('.block__product-fixed-button').removeClass("hidden")
        }else{
          $('.block__product-fixed-button').addClass("hidden");
        }
    });
}
$(document).on("click",".block__product-fixed-button-atc",function(){
  $(".product-form__submit").click();
   $('html,body').animate({
        scrollTop: $(".product-form__submit").offset().top  - 300},
        'slow');
})

  $(document).on("change" , ".block_subscription-options input" ,function () {  
    if($(this).hasClass("subscribe_product-multiple")){     
       $(this).parents(".block_product-grid_subscribe").find(".block_product-subscribe_drawer").addClass("active") 
      }else{
        $(this).parents(".block_product-grid_subscribe").find(".block_product-subscribe_drawer").removeClass("active")
      }   
  })
  $(document).on("click" ,".block_product-subscribe_multiple input" ,function(){
    if($(this).is(':checked')){
     let vals = $(this).parents(".block_product-grid_subscribe").find(".block_product-selling_plan_dropdown").val(); 
      $(this).parents(".quick-add-modal").find(".block_selling_plan_id").attr("value" , vals)
    }
  })




// $("a[href = '#'] ").click(function(e){
//     e.preventDefault();
//   $('html, body').animate({scrollTop:0}, '200');
//   })

  // $("a.handle-flavor-finder").click(function(){
  //    var target = window.location.hash;
  //   var offset = ($(this).attr('data-offset') ? $(this).attr('data-offset') : 0);
  //   $('body,html').animate({
  //       scrollTop: $(target).offset().top - 100
  //   }, 700);
  // })



  // Add smooth scrolling to all links
  $(document).on('click', ".handle-flavor-finder" ,function(event) {
    // event.preventDefault();

    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 800, function(){  
             // window.location.hash = hash;
     
    });
  });


$(".block_sign-up-retail").on("click" , function(){
  window.location.href = "/account/register";
})

$(document).on("click", ".block_bundle-remove" ,function(){
  let dataRemove = $(this).parents(".cart-item").attr("data-key-id");
  setTimeout(function(){
      $(`.block_bundle_product_price_info .block__delete_button[data-id = "${dataRemove}"]`).trigger("click")
  },100)
})

// $(document).on("click" , ".block_pop-up-text-inner .close_icon",function(){
// $(this).parents(".block_pop-up-text").addClass("active")
// })



$( document ).ready(function() {

function pops(){
	$(".block_pop-up-text").addClass("active")
	 var d = new Date();
	   var day = d.getDate();
	   $(document).on("click" , ".block_pop-up-text-inner .close_icon",function(){
		$(this).parents(".block_pop-up-text").addClass("active")
		 localStorage.setItem('now', day);
	   });
	
	   if (localStorage.getItem("now") == day) {
		$(".block_pop-up-text").addClass("active")
	   } else {
		$(".block_pop-up-text").removeClass("active")
		 localStorage.clear()
	   }
} 
	   setTimeout(pops, 100);
  }); 

  
})



$(document).ready(function(){
 if($(".template-index").length > 0 ){
  	$('.template-index .collection_slider ').slick({
		dots: false,
		infinite: true,
		centerMode: false,
		arrows: true,
		speed: 300,
		slidesToShow: 7,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '20px'
				}
			}
		]
	}); 
 }else{
     	$('.collection_slider ').slick({
		dots: false,
		infinite: true,
		centerMode: false,
		arrows: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '20px'
				}
			}
		]
	});
 }


	$('.block_image_main_banner').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 400,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		adaptiveHeight: true,
        dots:true
	  });
  
	$('.brand_list').slick({
		dots: false,
		infinite: false,
		arrows: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
           {
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					centerMode: true,
					variableWidth: true
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false
				}
			}
		]
	});

	$('.featured_slider').slick({
		dots: false,
		infinite: false,
		centerMode: false,
		arrows: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$(window).on("load" , function(){
		$(".block_annoucment_slider").show();

	})
	if ($(window).width() < 768) {
	$(".block_annoucment_slider").slick({
		speed: 40000,
		autoplay: true,
		autoplaySpeed: 0,
		variableWidth: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		swipeToSlide: true,
		centerMode: true,
		focusOnSelect: true	
	  });
	}
	
		$(".block_annoucment_slider-2").slick({
			speed: 40000,
			autoplay: true,
			autoplaySpeed: 0,
			variableWidth: true,
			cssEase: 'linear',
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			swipeToSlide: true,
			centerMode: true,
			focusOnSelect: true	
		  });

	
    $('.block_shipping_reorder_btn_inner').on('click', function(e) {
        var form = $(this).parents('#addToCart');
        e.preventDefault()

        $.ajax({
            type: 'POST',                             
            url: '/cart/add.js',
            dataType: 'json',                               
            data: form.serialize(),
            success: function(data) {			
				window.location = "/checkout";
            }
        });
    })

		
})


$(document).on("click", ".drawer-you-may-like .rebuy-button, .drawer-you-may-like .rebuy-button span , .rebuy-product-actions", function() {  
  console.log("click")
  setTimeout(function() {
     fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
          .then((response) => response.text())
          .then((responseText) => {
              const cartid = 'CartDrawer';
              const html = new DOMParser().parseFromString(responseText, 'text/html')
              const destination = document.querySelector('#CartDrawer');
              const source = html.getElementById(cartid);
              if (source && destination) destination.innerHTML = source.innerHTML;                      
              $.ajax({
                  url: '/?section_id=cart-icon-bubble',
                  type: 'GET',
                  dataType: 'html',
                  success: function(itemcount) {
                      $("#cart-icon-bubble").html($(itemcount).html());
                      $(".cart-count-bubble").trigger("click");                 
                  }
              });
          });
        }, 2000);
});

  $(document).ready(function() {
    if (window.location.href.indexOf("contact%5Btags%5D=newsletter&form_type=customer") > -1) {
       $(".old-subscriber").removeClass("hidden");
      $("#ContactFooter-error").addClass("hidden");
    }
    else {

         $(".old-subscriber").addClass("hidden");
    }
  });

  $(document).ready(function(){
	const $bundle_sample_atc_submit_event_new = async function($form_data){
	const $bundle_sample_addtocart_result_new = await fetch('/cart/add.json', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify($form_data)
	});
	const $bundle_atc_success_result_new = await $bundle_sample_addtocart_result_new.json();
	if($bundle_atc_success_result_new.items){
	  if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
	  const quickAddModal = document.querySelector('quick-add-modal');
	  if(quickAddModal){
		document.body.addEventListener('modalClosed', () => {
		  setTimeout(() => { document.querySelector('cart-drawer').renderContents($bundle_atc_success_result_new) });
		}, {once: true});
		quickAddModal.hide(true);
	  } else{
		document.querySelector('cart-drawer').renderContents($bundle_atc_success_result_new);
	  }
  
	} else{
	  console.error($bundle_atc_success_result_new);
	}
  }

  $(document).on('click', '.block_submit_button', function(e) {

    e.preventDefault(), e.stopImmediatePropagation();
    let $mainids = $(this).attr("pro-id");
    let sample_product_atc_array = [];
    let bundleID = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner").attr("data-bundle")
    let dateNow = Date.now()
    let selectedItems = "";
    let dataArr = [];
     let result ={};
      let catTitle = [];
    let catValue = [];
    $(".block_select_flovers_inner").each(function() {
    		selectedItems = {
    			"variantId": $(this).find(":selected").val(),
    			"quantity": 1,
    			"category": $(this).attr("data-title")
    		}
    		dataArr.push(selectedItems)
      catTitle.push($(this).attr("data-title"))
      catValue.push( $(this).find(":selected").attr("data-value"))

    });

    for (let i = 0; i <= catTitle.length; i++) {
      let key = catTitle[i];
      let value = catValue[i];      
      result[key] = value;
    }
    
	let qty = $(this).parents(".product__info-wrapper").find(".quantity__input").val();
      sample_product_atc_array.push({
          id: $mainids,
          quantity: qty,
          properties: {
              ...result,
              "__foxsell:dynamic_bundle_id": `${bundleID}_${dateNow}`,
              "__foxsell:dynamic_bundle_selected_items": JSON.stringify(dataArr)
          }
      });
  
      let sample_product_atc_formData = {
      	items: sample_product_atc_array,
      	sections_url: window.location.pathname,
      	sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)
      };

  
      let bundleSelectmain = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner").length;
      let bundleSelectval = $(this).parents(".product__info-wrapper").find(".block_select_flovers_inner.active").length;
      if ( bundleSelectmain == bundleSelectval) {
      	$bundle_sample_atc_submit_event_new(sample_product_atc_formData);
      }
    
    });
  })

// =================remove-cart-items=============


// $(document).on("click",".block_logout-btn",function(e){
// e.preventDefault();
// 	$.ajax({
// 		type: "POST",
// 		url: '/cart/clear.js',
// 		dataType: 'json',
// 		success: function() {
//             window.location.href="/account/logout"

// 		}
// 	})
//   });


// ==================end-cart-items===============
